export const CRC = 1
export const SUPORTE = 2
export const CONTEUDO = 3
export const SISGB = 4
export const CONVIDADO = 5